require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-uganda-gbv-cancellation.json") })
        }
      }, "path---en-us-update-uganda-gbv-cancellation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-uganda-gbv-cancellation!./.cache/json/en-us-update-uganda-gbv-cancellation.json
// module id = 816
// module chunks = 231608221292675